import { magistradoApi } from '@/api';
import Magistrado from '@/model/Magistrado';
import { OptionalId } from '@pjn/core/model/helpers/Types';

export default class MagistradoService {

    save(magistrado: OptionalId<Magistrado>): Promise<Magistrado> {
        if(magistrado.id){
            return magistradoApi.save(magistrado);
        } else {
            return magistradoApi.create(magistrado as Magistrado);
            }
    }
    
    findById(id: number): Promise<Magistrado> {
        return magistradoApi.findById(id);
    }
    
     delete(id: number) {
         return magistradoApi.deleteMagistrado(id);
    }

}